export const getDownloadCenterFileRows = (filesResponse) => {
  const fileObject = filesResponse?.fileObject?.fileObject || {};

  return Object.values(fileObject).map((file) => {
    const fileName = file.fileName || '';
    const pathParts = fileName.split('/');

    return {
      ...file,
      customer: pathParts[0] || '',
      folder: pathParts[1] || 'Files',
      displayName: pathParts[pathParts.length - 1] || fileName,
    };
  });
};

export const getDownloadCenterFolders = (fileRows) => {
  const folderMap = fileRows.reduce((foldersByName, file) => {
    if (!foldersByName[file.folder]) {
      foldersByName[file.folder] = {
        name: file.folder,
        count: 0,
      };
    }

    foldersByName[file.folder].count += 1;
    return foldersByName;
  }, {});

  return Object.values(folderMap);
};

export const getDownloadCenterInitialFolder = (filesResponse) => {
  const responseFolders = filesResponse?.folders || [];
  const responseFiles = getDownloadCenterFileRows(filesResponse);
  return filesResponse?.activeFolder || responseFolders[0]?.name || responseFiles[0]?.folder || '';
};

export const getDownloadCenterFolderPage = (filesResponse, folderName) => {
  const files = getDownloadCenterFileRows(filesResponse)
    .filter((file) => !folderName || file.folder === folderName);
  return { 
    files, continuationToken: filesResponse?.fileObject?.continuationToken || '', isLoading: false, 
  };
};

export const formatDownloadCenterDate = (dateValue) => {
  if (!dateValue) return 'Unknown date';

  return new Date(dateValue).toLocaleDateString();
};

export const formatDownloadCenterFileSize = (size) => {
  if (!size) return '0 KB';

  return `${Math.ceil(size / 1024).toLocaleString()} KB`;
};
